import { PropsWithChildren, useEffect, useState } from 'react'

import { useNavigate } from 'react-router-dom'

import { AosTokenContext } from './AosTokenContext'

export function AosTokenProvider({ children }: PropsWithChildren) {
  const [token, setToken] = useState<string | null>(null)
  const [expiry, setExpiry] = useState<string | null>(null)
  const navigate = useNavigate()

  useEffect(() => {
    if (expiry && new Date(expiry) < new Date()) {
      localStorage.removeItem('aosToken')
      localStorage.removeItem('aosTokenExpiry')
      setToken(null)
      setExpiry(null)
      navigate('/sign-in')
    }
  }, [expiry, navigate])

  useEffect(() => {
    if (!token) {
      const storedToken = localStorage.getItem('aosToken')
      const storedExpiry = localStorage.getItem('aosTokenExpiry')
      if (storedToken && storedExpiry) {
        setToken(storedToken)
        setExpiry(storedExpiry)
        return
      }

      if (window.location.pathname !== '/sign-in') {
        navigate('/sign-in')
      }
    }
  }, [token, navigate])

  return (
    <AosTokenContext.Provider value={{ token, setToken, expiry, setExpiry }}>
      {children}
    </AosTokenContext.Provider>
  )
}
